// Stage 201-S: pure builder for a witness-reframe engram.
//
// A witness-reframe records the moment the persona's WITNESS (the user)
// exhibited a pattern-flip. No Gadfly bite is involved, so the Stage-200
// self-reframe fields (subclass / acceptedBite / swat / rejectedSiblings)
// are OMITTED; the worker validator gates on reframeSubject and does not
// require them.
//
// Stage 202-W: the detector + optional semantic payload are threaded
// through from the detect response so the engram records HOW it was
// detected ('lexical-heuristic-v1' vs 'semantic-v1').

import type { LaughterEngramInput, WitnessReframeCue } from './types';

export interface WitnessSemantic {
  kind:
    | 'recognition'
    | 'surprise'
    | 'concession'
    | 'flip'
    | 'understanding'
    | 'none';
  confidence: 'high' | 'medium' | 'low';
  grounds: string;
}

export function buildWitnessReframeEngram(args: {
  conversationId: string;
  turnId: string;
  userMessage: string;
  normalisedText: string;
  cues: WitnessReframeCue[];
  firedAt: string;
  detector: 'lexical-heuristic-v1' | 'semantic-v1';
  semantic?: WitnessSemantic;
}): LaughterEngramInput {
  return {
    reframeSubject: 'witness',
    userMessage: args.userMessage,
    personaResponse: '', // not applicable — the witness reframed, not the persona
    turnId: args.turnId,
    conversationId: args.conversationId,
    firedAt: args.firedAt,
    witnessReframe: {
      userMessage: args.userMessage,
      normalisedText: args.normalisedText,
      cues: args.cues,
      detector: args.detector,
      ...(args.semantic ? { semantic: args.semantic } : {}),
    },
  };
}
